import { Component } from '@angular/core';
import { CardDesignComponent } from '../design/slide-up-card/card-design.component';
import { Overlay } from '@angular/cdk/overlay';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from '../../services/resize/resize.service';

@Component({
    template: '',
    standalone: false
})
export class PopUpComponent extends CardDesignComponent {
  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay
  ) {
    super(routePlanningService, resizeService, overlay);
  }
}
